import { computed, reactive, ref } from 'vue'
import * as api from './api'
import { FreeSubscriptionListFilterParameters } from '@/views/_shared/search-list/types'

export const typeOptions = [
    {
        label: 'Registration',
        value: 'registration'
    },
    {
        label: 'Trial',
        value: 'trial'
    }
]
export const processTypeOptions = [
    {
        label: 'Marketing Registration',
        value: 'marketing'
    },
    {
        label: 'Sales',
        value: 'sales'
    }
]
export const createdBy = ['Hrjapalkka']
const packages = ['Accountor', 'Accountor Group', 'Attendo', 'Esimies', 'Palkka', 'Talous', 'fi-total']

const freeSubscriptions = ref<api.GetFreeSubscriptionsListResponse['results']>([])
const freeSubscriptionsCount = ref(0)
const defaultSortBy = 'id desc'

export const freeSubscriptionsFilter = reactive<FreeSubscriptionListFilterParameters>({
    search: {
        subscriptionType: '',
        processType: '',
        createdBy: '',
        user: '',
        id: '',
        startDate: '',
        endDate: ''
    },
    sortBy: null,
    limit: 10,
    offset: 0
})

const getFreeSubscriptions = () =>
    api.getFreeSubscriptions(
        freeSubscriptionsFilter.search,
        freeSubscriptionsFilter.sortBy || defaultSortBy,
        freeSubscriptionsFilter.limit,
        freeSubscriptionsFilter.offset
    ).then(
        freeSubscriptionsList => {
            freeSubscriptionsCount.value = freeSubscriptionsList.count
            freeSubscriptions.value = freeSubscriptionsList.results
        }
    )

const withFreeSubscriptionUpdate = async (subscriptionId: string, callback: () => void) => {
    await callback()
    await getFreeSubscription(subscriptionId)
}

const getFreeSubscription = async (id: string) => {
    const freeSubscription = await api.getFreeSubscription(id)
    if (freeSubscriptions.value.length) {
        const freeSubscriptionIndex = freeSubscriptions.value.findIndex(value => value.subscriptionId === id)
        freeSubscriptions.value[freeSubscriptionIndex] = freeSubscription
    }
    return freeSubscription
}

const addFreeSubscription = (payload: api.AddFreeSubscriptionRequest) => api.addFreeSubscription(payload).then(getFreeSubscriptions)

const updateFreeSubscriptionEndDate = (id: string, payload: api.UpdateFreeSubscriptionEndDate) =>
    withFreeSubscriptionUpdate(id, () => api.updateFreeSubscriptionEndDate(id, payload))

const updateFreeSubscriptionPackages = (id: string, payload: api.UpdateFreeSubscriptionPackages) =>
    withFreeSubscriptionUpdate(id, () => api.updateFreeSubscriptionPackages(id, payload))

const deleteFreeSubscription = (id: string) => api.deleteFreeSubscription(id).then(getFreeSubscriptions)

export function useFreeSubscriptionsModule () {
    return {
        getFreeSubscriptions,
        freeSubscriptions: computed(() => freeSubscriptions.value),
        freeSubscriptionsCount: computed(() => freeSubscriptionsCount.value),
        freeSubscriptionsFilter,
        deleteFreeSubscription,
        addFreeSubscription,
        getFreeSubscription,
        updateFreeSubscriptionEndDate,
        updateFreeSubscriptionPackages,
        packages
    }
}
